<mat-accordion class="two-factor-faq-accordion block">
  <mat-expansion-panel
    [(expanded)]="panelOpenState"
    (afterExpand)="scrollIntoView(titleElem)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="!mr-0">
        <h3 #titleElem class="flex gap-14 items-center text-black w-full">
          <span class="mr-2">{{
            'two_factor_auth_faq_main_title' | translate
          }}</span>
          <mat-icon class="text-yellow ml-auto w-fit">
            {{ panelOpenState() ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-panel-description class="mt-[30px] !mr-0">
      <div
        class="two-factor-content flex-col lg:gap-[30px]"
        [class.lg:flex]="!isMobileView()"
        [class.lg:flex-row]="!isMobileView()"
      >
        <!-- Video Section -->
        <div
          class="video-container w-[250px] lg:flex-shrink-0 mb-[30px] down-lg:mx-auto"
          [class.mx-auto]="isMobileView()"
          [class.lg:mb-0]="!isMobileView()"
        >
          <video
            class="w-full h-auto rounded"
            muted="muted"
            playsinline="playsinline"
            preload="auto"
            poster="assets/images/2fa-guide.webp"
            controls
          >
            <source src="assets/videos/2fa-guide.mp4" type="video/mp4" />
            {{ 'browser_not_supporting_video' | translate }}
          </video>
        </div>

        <!-- Text Content Section -->
        <div class="text-content lg:flex-1 text-black text-sm">
          <!-- Question 1 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q1_title' | translate }}
            </h4>
            <p class="mb-4">
              {{ 'two_factor_auth_faq_q1_desc_1' | translate }}
            </p>
            <p
              class="mb-4"
              [innerHTML]="'two_factor_auth_faq_q1_desc_2' | translate"
            ></p>
            <p [innerHTML]="'two_factor_auth_faq_q1_desc_3' | translate"></p>
          </div>

          <!-- Question 2 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q2_title' | translate }}
            </h4>
            <ul class="list-disc pl-5">
              <li
                [innerHTML]="'two_factor_auth_faq_q2_android' | translate"
              ></li>
              <li [innerHTML]="'two_factor_auth_faq_q2_ios' | translate"></li>
            </ul>
            <p
              class="mt-4"
              [innerHTML]="'two_factor_auth_faq_q2_warning' | translate"
            ></p>
          </div>

          <!-- Question 3 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q3_title' | translate }}
            </h4>
            <ol class="list-decimal pl-5">
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q3_step1' | translate }}
              </li>
              <li
                class="mb-2"
                [innerHTML]="'two_factor_auth_faq_q3_step2' | translate"
              ></li>
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q3_step3' | translate }}
              </li>
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q3_step4' | translate }}
              </li>
              <li>{{ 'two_factor_auth_faq_q3_step5' | translate }}</li>
            </ol>
          </div>

          <!-- Question 4 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q4_title' | translate }}
            </h4>
            <ol class="list-decimal pl-5">
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q4_step1' | translate }}
              </li>
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q4_step2' | translate }}
              </li>
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q4_step3' | translate }}
              </li>
              <li>{{ 'two_factor_auth_faq_q4_step4' | translate }}</li>
            </ol>
          </div>

          <!-- Question 5 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q5_title' | translate }}
            </h4>
            <ul class="list-disc pl-5">
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q5_item1' | translate }}
              </li>
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q5_item2' | translate }}
              </li>
              <li>{{ 'two_factor_auth_faq_q5_item3' | translate }}</li>
            </ul>
          </div>

          <!-- Question 6 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q6_title' | translate }}
            </h4>
            <ul class="list-disc pl-5">
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q6_item1' | translate }}
              </li>
              <li class="mb-2">
                {{ 'two_factor_auth_faq_q6_item2' | translate }}
              </li>
              <li>{{ 'two_factor_auth_faq_q6_item3' | translate }}</li>
            </ul>
          </div>

          <!-- Question 7 -->
          <div class="mb-[30px]">
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q7_title' | translate }}
            </h4>
            <p>{{ 'two_factor_auth_faq_q7_desc' | translate }}</p>
          </div>

          <!-- Question 8 -->
          <div>
            <h4 class="font-bold mb-4">
              {{ 'two_factor_auth_faq_q8_title' | translate }}
            </h4>
            <p
              [innerHTML]="
                'two_factor_auth_faq_q8_desc'
                  | translate: { url: contactPageUrl }
                  | sanitize
              "
            ></p>
          </div>
        </div>
      </div>
    </mat-panel-description>
  </mat-expansion-panel>
</mat-accordion>
